/* eslint-disable import/prefer-default-export */
import { TIME_FORMAT } from 'athena/components/constants';
import { TimeZoneData } from 'athena/hooks/use-time-zone';
import moment from 'moment';
import { PulseCheckQuestion } from 'redux/schemas/models/mentoring-program-sessions';

const DATE_FORMAT = 'ddd, MMMM D';

export const formatSessionTime = (dateString: string, duration: number, timeZone: TimeZoneData) => {
  const { ianaTimeZone, timeZoneAbbreviation } = timeZone;
  try {
    const startTime = moment.tz(dateString, ianaTimeZone);
    const endTime = duration ? startTime.clone().add(duration, 'minutes') : null;
    const formattedStartTime = startTime.format(`${DATE_FORMAT} • ${TIME_FORMAT}`);
    const formattedEndTime = endTime ? ` - ${endTime.format(TIME_FORMAT)}` : '';
    return `${formattedStartTime}${formattedEndTime} ${timeZoneAbbreviation}`;
  } catch (error) {
    return '';
  }
};

export const sortByQuestionIndex = (
  firstQuestion: PulseCheckQuestion,
  secondQuestion: PulseCheckQuestion,
) => {
  const { questionIndex: firstQuestionIndex } = firstQuestion || {};
  const { questionIndex: secondQuestionIndex } = secondQuestion || {};
  return firstQuestionIndex - secondQuestionIndex;
};
